import React from 'react'

const TextInputWrapper = React.forwardRef((props, ref) => (
  <div className='form-group row'>
    <label className={`control-label col-lg-${props.labelColSize}`} htmlFor={props.name}>{props.label}</label>
    <div className={`col-lg-${props.inputColSize}`}>
      <input 
        {...(_.omit(props, 'labelColSize', 'inputColSize'))}
        className='form-control' 
        ref={ref}
        onChange={props.onChange}
      />
    </div>
  </div>
))

export default TextInputWrapper
